import React, { useEffect, useState } from 'react'
import Sidebar from '../../AluminiAdminDashboardDesign/sidebar'
import NavLogo from '../../AluminiAdminDashboardDesign/NavLogo'
import { Col, Row } from 'react-bootstrap'
import { MDBDataTable } from 'mdbreact'
import axios from 'axios'
import { AdminMessFeedbackApi } from '../../ApiFile'
import MobileNavbarAdmin from '../../AluminiAdminDashboardDesign/pages/MobileNavbarAdmin'

const FeedBack = () => {
  const [rows, setRows] = useState([])

  const fetchData = () => {
    axios
      .get(AdminMessFeedbackApi)
      .then((response) => {
        const mappedRows = response.data.map((row, index) => ({
          ...row,
          Name: row.name,
        }))
        setRows(mappedRows)
      })
      .catch((error) => {
        // console.error(error);
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  const data = {
    columns: [
      { label: 'Sr.No', field: 'srNo' },
      { label: 'Student Name', field: 'name', width: 150 },
      { label: 'Feedback Date', field: 'feedback_date', width: 150 },
      { label: 'Block No', field: 'block_id', width: 150 },
      { label: 'Room No', field: 'room_id', width: 150 },
      {
        label: 'Feedback',
        field: 'feedback',
        sort: 'asc',
        width: 270,
      },
    ],
    rows: rows.map((row, index) => ({
      srNo: index + 1,
      ...row,
    })),
  }

  return (
    <>
         <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
            {/* Sidebar on the left for desktop */}
            <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
              <Sidebar />
            </div>
      
            {/* Main content on the right */}
            <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
              <NavLogo />
             
                   <div className="d-block d-md-none">
                     <MobileNavbarAdmin />
                   </div>

        <div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
            Mess Feedback
            </h5>
          </div>

        <Row
          className="m-0 p-0 px-md-3 py-1 pb-5 mb-5 mt-4 w-100"
          style={{ display: 'flex' }}
        >
          <Col
            className="m-0 p-0 px-3 py-3 rounded shadow"
            style={{ background: 'white' }}
          >
            <div style={{ overflowY: 'auto' }}>
              <div style={{ overflowX: 'auto' }}>
                <MDBDataTable
                  striped
                  className="custom-datatable text-center"
                  bordered
                  hover
                  small
                  data={data}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      </div>
      </div>
    </>
  )
}

export default FeedBack
